import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { UseHandleCustomers } from "0.Mine/1.Hooks/CRM/Customers";
import { useBusinessContext } from "0.Mine/2.Context/businessContext";
import { Customer } from "0.Mine/3.Interfaces/customer";

import { BookingDetailView } from "./DetailView";
import { BookingTable } from "./TableView";

interface TableProps {
  bookings: Customer[];
  deleteBooking: (bookingId: number) => void;
}

const Table = ({ bookings, deleteBooking }: TableProps) => {
  const [open, setOpen] = React.useState(false);
  const [selectedBooking, setSelectedBooking] = React.useState<Customer | null>(null);
  const { session } = useBusinessContext();
  const handleRowClick = (booking: Customer) => {
    setSelectedBooking(booking);
    setOpen(true);
  };
  const { t } = useTranslation();

  const handleClose = () => {
    setOpen(false);
  };

  const deleteBookingFromTable = (bookingId: number) => {
    deleteBooking(bookingId);
  };

  // Check if we have a valid businessId
  const businessId = session?.selectedBusiness?.id;

  // If session exists but selectedBusiness is null, show a message
  if (session && !session.selectedBusiness) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography>{t("customerTable.selectABusiness")}</Typography>
      </Box>
    );
  }

  return (
    <div>
      <BookingTable bookings={bookings} onRowClick={handleRowClick} />
      {selectedBooking && businessId && (
        <BookingDetailView
          open={open}
          onClose={handleClose}
          booking={selectedBooking}
          businessId={businessId}
          deleteBookingFromTable={deleteBookingFromTable}
        />
      )}
    </div>
  );
};

export default Table;
